module.exports = __webpack_public_path__ + "static/media/masjid_kichula9.57c73c4b.webp";